webpackJsonp([252088872356810],{

/***/ 2560:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/step-7.32e8ba30.png";

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _step = __webpack_require__(2560);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 7: Add Delete Link'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to add a "delete" link to tweets that, when clicked, will launch a dialog to delete the tweet.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'dialogs.7' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'The Destroy Action'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The dialog we\'ll create in this step will allow us to delete a tweet, and we\'ll be invoking the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'destroy'
	      ),
	      ' action to do that. Assuming you have a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet'
	      ),
	      ' you want to delete, you invoke the action like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      lore.actions.tweet.destroy(tweet)\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The argument is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet'
	      ),
	      ' you want to destroy.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If we assume the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' of this tweet is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '1'
	      ),
	      ', then invoking this action will send a DELETE request to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337/tweets/1'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'destroy'
	        ),
	        ' action ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/actions/destroy/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Create Delete Link'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Run this command to create a component for our delete link:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate component DeleteLink\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then update the component to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'DeleteLink\',\n\n          propTypes: {\n            tweet: PropTypes.object.isRequired\n          },\n\n          onClick() {\n            const { tweet } = this.props;\n\n            lore.dialog.show(function() {\n              return lore.dialogs.tweet.destroy(tweet, {\n                blueprint: \'optimistic\',\n                request: function(data) {\n                  return lore.actions.tweet.destroy(tweet).payload;\n                }\n              });\n            });\n          },\n\n          render() {\n            return (\n              <a className="link" onClick={this.onClick}>\n                delete\n              </a>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class DeleteLink extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            const { tweet } = this.props;\n\n            lore.dialog.show(function() {\n              return lore.dialogs.tweet.destroy(tweet, {\n                blueprint: \'optimistic\',\n                request: function(data) {\n                  return lore.actions.tweet.destroy(tweet).payload;\n                }\n              });\n            });\n          }\n\n          render() {\n            return (\n              <a className="link" onClick={this.onClick}>\n                delete\n              </a>\n            );\n          }\n\n        }\n\n        DeleteLink.propTypes = {\n          tweet: PropTypes.object.isRequired\n        };\n\n        export default DeleteLink;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class DeleteLink extends React.Component {\n\n          static propTypes = {\n            tweet: PropTypes.object.isRequired\n          };\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            const { tweet } = this.props;\n\n            lore.dialog.show(function() {\n              return lore.dialogs.tweet.destroy(tweet, {\n                blueprint: \'optimistic\',\n                request: function(data) {\n                  return lore.actions.tweet.destroy(tweet).payload;\n                }\n              });\n            });\n          }\n\n          render() {\n            return (\n              <a className="link" onClick={this.onClick}>\n                delete\n              </a>\n            );\n          }\n\n        }\n\n        export default DeleteLink;\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we\'re rendering a link with an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'onClick'
	      ),
	      ' callback. When clicked, we\'ll show a confirmation dialog, and then invoke the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'destroy'
	      ),
	      ' action when the request is confirmed.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add a Delete Link to the Tweet'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we want to add the delete link to each tweet. Open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Tweet'
	      ),
	      ' component and update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Tweet.js\n      ...\n      import DeleteLink from \'./DeleteLink\';\n      ...\n        render() {\n          ...\n          return (\n            <li className="list-group-item tweet">\n              <div className="image-container">\n                <img\n                  className="img-circle avatar"\n                  src={user.data.avatar} />\n              </div>\n              <div className="content-container">\n                <h4 className="list-group-item-heading title">\n                  {user.data.nickname}\n                </h4>\n                <h4 className="list-group-item-heading timestamp">\n                  {\'- \' + timestamp}\n                </h4>\n                <p className="list-group-item-text text">\n                  {tweet.data.text}\n                </p>\n                <div className="tweet-actions">\n                  <EditLink tweet={tweet} />\n                  <DeleteLink tweet={tweet} />\n                </div>\n              </div>\n            </li>\n          );\n        }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With this change in place, refresh the browser and you should see a ',
	      _react2.default.createElement(
	        'em',
	        null,
	        '"delete"'
	      ),
	      ' link on each of the tweets.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you click this link, you\'ll be asked to confirm that you want to delete the tweet. Once you confirm, if you look at the network requests, you\'ll see a DELETE request is sent to the API to delete the tweet.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'The ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'state'
	        ),
	        ' of the tweet is also changed to ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'DELETING'
	        ),
	        ', so if this were a real application, we could add an if statement to detect when data was being changed and modify our UI to communicate that to the user.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _step2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/DeleteLink.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'DeleteLink\',\n\n          propTypes: {\n            tweet: PropTypes.object.isRequired\n          },\n\n          onClick() {\n            const { tweet } = this.props;\n\n            lore.dialog.show(function() {\n              return lore.dialogs.tweet.destroy(tweet, {\n                blueprint: \'optimistic\',\n                request: function(data) {\n                  return lore.actions.tweet.destroy(tweet).payload;\n                }\n              });\n            });\n          },\n\n          render() {\n            return (\n              <a className="link" onClick={this.onClick}>\n                delete\n              </a>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class DeleteLink extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            const { tweet } = this.props;\n\n            lore.dialog.show(function() {\n              return lore.dialogs.tweet.destroy(tweet, {\n                blueprint: \'optimistic\',\n                request: function(data) {\n                  return lore.actions.tweet.destroy(tweet).payload;\n                }\n              });\n            });\n          }\n\n          render() {\n            return (\n              <a className="link" onClick={this.onClick}>\n                delete\n              </a>\n            );\n          }\n\n        }\n\n        DeleteLink.propTypes = {\n          tweet: PropTypes.object.isRequired\n        };\n\n        export default DeleteLink;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class DeleteLink extends React.Component {\n\n          static propTypes = {\n            tweet: PropTypes.object.isRequired\n          };\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            const { tweet } = this.props;\n\n            lore.dialog.show(function() {\n              return lore.dialogs.tweet.destroy(tweet, {\n                blueprint: \'optimistic\',\n                request: function(data) {\n                  return lore.actions.tweet.destroy(tweet).payload;\n                }\n              });\n            });\n          }\n\n          render() {\n            return (\n              <a className="link" onClick={this.onClick}>\n                delete\n              </a>\n            );\n          }\n\n        }\n\n        export default DeleteLink;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Tweet.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n        import EditLink from \'./EditLink\';\n        import DeleteLink from \'./DeleteLink\';\n\n        export default connect(function(getState, props) {\n          const { tweet } = props;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })(\n        createReactClass({\n          displayName: \'Tweet\',\n\n          propTypes: {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          },\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                  <div className="tweet-actions">\n                    <EditLink tweet={tweet} />\n                    <DeleteLink tweet={tweet} />\n                  </div>\n                </div>\n              </li>\n            );\n          }\n\n        })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n        import EditLink from \'./EditLink\';\n        import DeleteLink from \'./DeleteLink\';\n\n        class Tweet extends React.Component {\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                  <div className="tweet-actions">\n                    <EditLink tweet={tweet} />\n                    <DeleteLink tweet={tweet} />\n                  </div>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        Tweet.propTypes = {\n          tweet: PropTypes.object.isRequired,\n          user: PropTypes.object.isRequired\n        };\n\n        export default connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })(Tweet);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n        import EditLink from \'./EditLink\';\n        import DeleteLink from \'./DeleteLink\';\n\n        @connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })\n        class Tweet extends React.Component {\n\n          static propTypes = {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          };\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                  <div className="tweet-actions">\n                    <EditLink tweet={tweet} />\n                    <DeleteLink tweet={tweet} />\n                  </div>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        export default Tweet;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the next section we\'ll be ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../authorization/overview/' },
	        'hiding the edit and delete links'
	      ),
	      ' to reflect the application\'s user permissions.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-dialogs-step-7-js-e9f0b27eb86df9533a86.js